<form [formGroup]="formRating()" class="flex flex-col items-center justify-center p-7">
    <span class="font-bold text-[15px] text-brand-main-dark mb-1">
        @defer (when !isLoading()) {
            {{ renderOrder()?.laboratory?.name }}
        } @placeholder (minimum 1000) {
            <ngx-skeleton-loader [theme]="{ 'width.px': 200, 'height.px': 20 }" class="mb-1" />
        }
    </span>

    @if (!!renderOrder().patient) {
        <span class="flex flex-row items-center justify-center font-semiBold text-[13px] text-brand-main-dark mb-1">
            @defer (when !isLoading()) {
                <mat-icon svgIcon="feather:user" class="size-18 mr-1 text-brand-main-dark" />
                {{ renderOrder().patient }}
            } @placeholder (minimum 1000) {
                <ngx-skeleton-loader [theme]="{ 'width.px': 18, 'height.px': 18 }" class="mr-1" />
                <ngx-skeleton-loader [theme]="{ 'width.px': 80, 'height.px': 17 }" />
            }
        </span>
    }

    <div class="flex flex-col items-center justify-center w-full border-t-[1px] border-kiwid-divider mt-4 pt-4">
        @defer (when !isLoading()) {
            @for (ratingType of ratingTypes(); track ratingType.id) {
                <div class="flex flex-col items-center justify-center w-full mb-3">
                    <span class="font-semiBold text-[13px] text-brand-main-dark mb-1">{{ ratingType.name }}</span>
                    <div class="flex flex-row items-center justify-center gap-1">
                        <mat-icon
                            class="cursor-pointer size-24"
                            [class.text-neutral-light]="ratingType.value < 1"
                            [class.text-ui-warning-default]="ratingType.value >= 1"
                            (click)="setRatingValue(ratingType.id, 1)"
                        >
                            star
                        </mat-icon>

                        <mat-icon
                            class="cursor-pointer size-24"
                            [class.text-neutral-light]="ratingType.value < 2"
                            [class.text-ui-warning-default]="ratingType.value >= 2"
                            (click)="setRatingValue(ratingType.id, 2)"
                        >
                            star
                        </mat-icon>

                        <mat-icon
                            class="cursor-pointer size-24"
                            [class.text-neutral-light]="ratingType.value < 3"
                            [class.text-ui-warning-default]="ratingType.value >= 3"
                            (click)="setRatingValue(ratingType.id, 3)"
                        >
                            star
                        </mat-icon>

                        <mat-icon
                            class="cursor-pointer size-24"
                            [class.text-neutral-light]="ratingType.value < 4"
                            [class.text-ui-warning-default]="ratingType.value >= 4"
                            (click)="setRatingValue(ratingType.id, 4)"
                        >
                            star
                        </mat-icon>

                        <mat-icon
                            class="cursor-pointer size-24"
                            [class.text-neutral-light]="ratingType.value < 5"
                            [class.text-ui-warning-default]="ratingType.value >= 5"
                            (click)="setRatingValue(ratingType.id, 5)"
                        >
                            star
                        </mat-icon>
                    </div>
                </div>
            }

            <mat-form-field class="w-full mt-2">
                <mat-label>{{ 'MODAL_CREATE_RATING.COMMENTS' | translate }}</mat-label>
                <textarea matInput formControlName="comment" [rows]="5"></textarea>
            </mat-form-field>
        } @placeholder (minimum 1000) {
            <div class="flex flex-col items-center justify-center gap-2">
                <ngx-skeleton-loader [theme]="{ 'width.px': 200, 'height.px': 19 }" class="mr-1" />
                <ngx-skeleton-loader class="flex flex-row items-center justify-center gap-1" [count]="5" [theme]="{ 'width.px': 24, 'height.px': 24 }" />
            </div>

            <div class="flex flex-col items-center justify-center gap-2 mt-3">
                <ngx-skeleton-loader [theme]="{ 'width.px': 200, 'height.px': 19 }" class="mr-1" />
                <ngx-skeleton-loader class="flex flex-row items-center justify-center gap-1" [count]="5" [theme]="{ 'width.px': 24, 'height.px': 24 }" />
            </div>

            <div class="flex flex-col items-center justify-center gap-2 mt-3">
                <ngx-skeleton-loader [theme]="{ 'width.px': 200, 'height.px': 19 }" class="mr-1" />
                <ngx-skeleton-loader class="flex flex-row items-center justify-center gap-1" [count]="5" [theme]="{ 'width.px': 24, 'height.px': 24 }" />
            </div>

            <div class="flex flex-col items-center justify-center gap-2 my-3">
                <ngx-skeleton-loader [theme]="{ 'width.px': 200, 'height.px': 19 }" class="mr-1" />
                <ngx-skeleton-loader class="flex flex-row items-center justify-center gap-1" [count]="5" [theme]="{ 'width.px': 24, 'height.px': 24 }" />
            </div>

            <ngx-skeleton-loader class="w-full mt-2" [theme]="{ 'width': 100, 'height.px': 180 }" />
        }
    </div>
</form>
